import * as React from 'react'
import { Dropdown, DropdownItem, DropdownList, Divider, MenuToggle, MenuToggleElement, Modal, ModalVariant, Button } from '@patternfly/react-core';
import {
    useRouteMatch
} from 'react-router-dom';
import { CLUSTER, SECRET_MANAGER_INSTANCES } from '@app/config';

const ClusterPopUp: React.FunctionComponent<{isModalOpen: boolean, handleModalToggle: () => void, details}> = ({ isModalOpen, handleModalToggle, details}) => {

    if (details === undefined) {
        return null
    }

    return (<Modal
        variant={ModalVariant.small}
        title="You are being redirected"
        isOpen={isModalOpen}
        onClose={handleModalToggle}
      ><p>
        The secret manager portal for the cluster <b>{details.name.toUpperCase()}</b> is published on a different url
        { details.requires_vpn && <> and requires connection to the <a href='https://teladochealth.atlassian.net/wiki/x/sP3qCw'>cluster's vpn</a></>}
         .<br /><br />
        <a href={details.url}>Click here</a> to start the redirection.
        </p>
      </Modal>);
 }



const ClusterSelection: React.FunctionComponent<{}> = ({ }) => {
    const [isOpen, setIsOpen] = React.useState(false);
    const [isPopUpOpen, setIsPopUpOpen] = React.useState(false);
    const [cluster, setCluster] = React.useState<{} | undefined>(undefined);

    const { path, url } = useRouteMatch<{ path: string, url: string }>();

    if (SECRET_MANAGER_INSTANCES === undefined || SECRET_MANAGER_INSTANCES.length === 1) {
        return null;
    }

    const SecretManagerClusters = SECRET_MANAGER_INSTANCES.filter(cluster => cluster.alias !== CLUSTER).map(cluster => ({...cluster, url: cluster.url + path}))

    const onToggleClick = () => {
        setIsOpen(!isOpen);
    };

    const onClusterSelected = (details) => {
        setCluster(details);
        setIsPopUpOpen(true);
        setIsOpen(!isOpen);
        return null;
    }

    const handleModalToggle = () => {
        setIsPopUpOpen(!isPopUpOpen);
    }

    return (
        <>
        <ClusterPopUp isModalOpen={isPopUpOpen} handleModalToggle={handleModalToggle} details={cluster} />
        <div className="secrets-cluster-bar">
            <span className="secrets-cluster-label">Cluster</span>
            <Dropdown
                isOpen={isOpen}
                onOpenChange={(isOpen: boolean) => setIsOpen(isOpen)}
                onSelect={() => { }}
                toggle={(toggleRef: React.Ref<MenuToggleElement>) => (
                    <MenuToggle ref={toggleRef} onClick={onToggleClick} isExpanded={isOpen} className="secrets-cluster-toggle">
                        {SECRET_MANAGER_INSTANCES.find(cluster => cluster.alias === CLUSTER)?.name}
                    </MenuToggle>
                )}
                ouiaId="BasicDropdown"
                shouldFocusToggleOnSelect
            >
                <DropdownList>
                    { SecretManagerClusters.map((cluster, idx) => (
                        <DropdownItem value={idx} key="action" onClick={() => onClusterSelected(cluster)}>
                            {cluster.name}
                        </DropdownItem>
                    ))}
                    <Divider/>
                    <DropdownItem value={'other'} key="action" to="https://teladochealth.atlassian.net/wiki/spaces/DEVOPS/pages/199887645/EOD+Dashboard+Secret+Manager#id-[EODDashboard]SecretManager-instances">
                        Other
                    </DropdownItem>
                </DropdownList>
            </Dropdown>
        </div>
        </>
    )
}

export { ClusterSelection };